import { FilterTypes, TextFilterModelTypes } from '@amzn/unified-data-table-components/core';

export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_COLUMN_STATE: string[] = [];
export const DEFAULT_PAGE_OFFSET = 0;
export const PREFETCH_ADVERTISER_COUNT = 300;

const DEFAULT_SEARCH_FILTER = { searchExpression: { filterType: FilterTypes.TEXT, type: TextFilterModelTypes.CONTAINS, filter: '' } };
//Any new default filters can be added to this DEFAULT_FILTER_STATE
export const DEFAULT_FILTER_STATE = Object.assign({}, DEFAULT_SEARCH_FILTER);
